module.exports = __webpack_public_path__ + "static/media/feature_flag_main_visual_mobile.d19d81f9.png";